module.exports = __webpack_public_path__ + "static/av-flag-video-3e2a0cc191bb00238afe5c841ccdc5d1.mp4";